export default __webpack_public_path__ + "static/116-1e2efdc318bceeab7c36439a37377e78.jpg";